import { render, staticRenderFns } from "./StudentStudyCategoryProgress.vue?vue&type=template&id=2ba24980&lang=pug&"
import script from "./StudentStudyCategoryProgress.vue?vue&type=script&lang=ts&"
export * from "./StudentStudyCategoryProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports